var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { FieldLayout, Label } from "../FieldLayout";
import { FormGroupContextProvider, useFormGroupContext } from "../FormGroupContext";
import { createUIElement } from "../helpers";
export var LabelGroupInnerLayout = styled.td(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 0;\n    outline: 0;\n"], ["\n    padding: 0;\n    outline: 0;\n"])));
export var LabelGroupLayout = styled.tr(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    > ", " ", " {\n        margin-right: ", ";\n    }\n\n    > ", " > * {\n        transform: translateY(", ");\n    }\n"], ["\n    > ", " ", " {\n        margin-right: ", ";\n    }\n\n    > ", " > * {\n        transform: translateY(", ");\n    }\n"])), Label.selector, FieldLayout.selector, function (_a) {
    var theme = _a.theme;
    return theme.spacing.s;
}, Label.selector, function (_a) {
    var hasTopOffset = _a.hasTopOffset;
    return (hasTopOffset ? '20px' : '0');
});
export var LabelGroup = createUIElement('LabelGroup', function (_a, ref) {
    var className = _a.className, asTag = _a.asTag, label = _a.label, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.hidden, hidden = _c === void 0 ? false : _c, children = _a.children, hasTopOffset = _a.hasTopOffset, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "asTag", "label", "disabled", "hidden", "children", "hasTopOffset", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var _d = useFormGroupContext(), groupDisabled = _d.disabled, groupHidden = _d.hidden;
    if (groupHidden || hidden) {
        return null;
    }
    var isDisabled = groupDisabled || disabled;
    var labelElement = React.isValidElement(label)
        ? React.cloneElement(label, { disabled: isDisabled })
        : label;
    return (React.createElement(FormGroupContextProvider, { value: { disabled: groupDisabled || disabled, hidden: hidden } },
        React.createElement(LabelGroupLayout, __assign({}, rest, { "data-selector-id": rest['data-selector-id'], className: "vm-LabelGroup " + className, hasTopOffset: hasTopOffset, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
            React.createElement(Label, { disabled: isDisabled, asTag: asTag === 'tr' ? 'td' : 'div' }, labelElement),
            React.createElement(LabelGroupInnerLayout, null, children))));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=LabelGroup.js.map